import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SESSION_CONFIG } from './session-config';
import { SessionService } from './session.service';

/**
 * Rutas con sesión. Sin usuario guardado manda a `routes.signedOut`; con él, si tiene un paso
 * pendiente (`routes.pendingStep`), lo manda ahí salvo que ya vaya a esa ruta.
 */
export const authGuard: CanActivateFn = async (_route, state) => {
  // Todo antes del primer await: inject() sólo funciona en la parte síncrona del guard.
  const session = inject(SessionService);
  const router = inject(Router);
  const { routes } = inject(SESSION_CONFIG);

  const authenticated = await session.isAuthenticated();
  if (!authenticated) {
    return router.createUrlTree([routes.signedOut]);
  }

  const user = await session.getStoredUser();
  const step = routes.pendingStep?.(user) ?? null;
  if (step && !state.url.startsWith(step)) {
    return router.createUrlTree([step]);
  }
  return true;
};

/** Rutas para quien no ha iniciado sesión (bienvenida, login): con usuario guardado, a su inicio. */
export const guestGuard: CanActivateFn = async () => {
  const session = inject(SessionService);
  const router = inject(Router);
  const { routes } = inject(SESSION_CONFIG);

  const user = await session.getStoredUser();

  if (!user) {
    return true;
  }

  return router.createUrlTree([routes.home(user)]);
};
